const SimpleCollapseVanilla = function() {
    const __constructor = function() {
        const simpleCollapseItems = document.querySelectorAll('.simple-collapse-js-init');
        if (simpleCollapseItems.length === 0) {
            return;
        }

        simpleCollapseItems.forEach(InitializeCollapseItem);
    }

    /**
     * @param {Element} item
     * @constructor
     */
    const InitializeCollapseItem = function(item) {
        if (item.classList.contains('simple-collapse-initialized')) {
            return;
        }

        const button = item.querySelector('.simple-collapse__button');
        const content = item.querySelector('.simple-collapse__content');
        if (!button || !content) {
            return;
        }

        button.addEventListener('click', () => {
            item.classList.toggle('open');
            content.ariaExpanded = item.classList.contains('open');
            content.ariaHidden = !item.classList.contains('open');
        });

        item.classList.remove('simple-collapse-js-init');
        item.classList.add('simple-collapse-initialized');
    }

    document.addEventListener('DOMContentLoaded', function() {
        __constructor();
    });
}

export default SimpleCollapseVanilla;
